import { AbstractControl, ValidationErrors } from '@angular/forms';
import { getUtcToday } from '../date';
import { getUtcDate } from '../date/get-utc-date';

export function lessOrEqualThanTodayValidator(
  control: AbstractControl
): ValidationErrors | null {
  const todayUtcDate = getUtcToday();
  const formControlUtcDate = getUtcDate(new Date(control.value));
  const isLessThanToday = formControlUtcDate <= todayUtcDate;
  const rv = isLessThanToday ? null : { lessThanToday: true };
  return rv;
}
